import { useContext, useEffect, useState } from "react";
import { GET_ALL_GIF_ADS, fetchData } from "../../../components/Service";
import { Context } from "../../../components/Context";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";

const Ads = (props) => {
	const [ads, setAds] = useState([]);
	const [context] = useContext(Context);

	const getAds = (country_id, type) => {
		let value = {
			country_id: country_id,
			ad_position: type,
		};
		fetchData(GET_ALL_GIF_ADS, "POST", value, false, false, (res) => {
			if (res.status) {
				setAds(res?.data);
			} else {
				setAds([]);
			}
		});
	};

	useEffect(() => {
		if (context?.countryId) {
			getAds(context?.countryId, props.adsType);
		}
	}, [context, props.adsType]);
	return (
		<div className={`${props.adsType}_proimage`}>
			{props.limit
				? ads?.slice(0, props.limit).map((item, index) => (
						<p key={item.id || index}>
							<Link  to={`${item?.click_url}`} target="_blank">
								<img src={item.image} alt="..." />
							</Link>
						</p>
				  ))
				: ads?.map((item, index) => (
						<p key={item.id || index}>
							<Link to={`${item?.click_url}`} target="_blank">
								<img src={item.image} alt="..." />
							</Link>
						</p>
				  ))}
		</div>
	);
};

export default Ads;
